
import { AxiosError } from "axios";

interface axiosErrorResponse {
  error: Error;
}
interface Error {
  code: number
  message: string
  type: string
  kind: string
  issues: any[]
  cause: Cause
}

interface Cause {
  code: number
  type: any
  kind: string
  message: string
  issues: any[]
  cause: any
}

export const GetError = (error:any): { message: string, kind: string | undefined } => {
  error as AxiosError
  let message = error.message;
  let kind: string | undefined = undefined;
  if (error.response && error.response.data) {
    try {
      const data = error.response.data as axiosErrorResponse;
      if (data.error.message) {
        message = data?.error?.message;
        kind=data?.error?.kind;
      }
      if(data?.error?.cause)
      {
        if (data?.error?.cause?.message) message = data?.error?.cause?.message;
        if (data?.error?.cause?.kind) kind = data?.error?.cause?.kind;
      }
    } catch (e) {
      console.log(e);
    }
  }

  return { message, kind };
};